// @flow
import React, { Fragment } from 'react';
import PageTemplate from 'components/base/PageTemplate';
import SearchResultsContainer from 'containers/search/SearchResultsContainer';
import SearchTemplate from 'components/search/SearchTemplate';
import SearchTab from 'components/search/SearchTab/SearchTab';
import SearchBoxContainer from 'containers/search/SearchBoxContainer';
import MainMobileHeadContainer from 'containers/main/MainMobileHeadContainer';
import MainHeadContainer from 'containers/main/MainHeadContainer';
import MainMobileFooter from 'components/main/MainMobileFooter';
import { type ContextRouter } from 'react-router-dom';
import queryString from 'query-string';

type Props = {
  location: any,
  match: any,
  history: any,
} & ContextRouter;

const Search = ({ location, match, history }: Props) => {
  const { menu, q } = queryString.parse(location.search);

  return (
    <PageTemplate>
      <header>
        <MainHeadContainer />
        <MainMobileHeadContainer />
      </header>
      <SearchTemplate searchBox={<SearchBoxContainer />}>
        <Fragment>
          <SearchTab menu={menu} q={q} />
          <SearchResultsContainer menu={menu} />
        </Fragment>
      </SearchTemplate>
      <MainMobileFooter />
    </PageTemplate>
  );
};

export default Search;



// WEBPACK FOOTER //
// ./src/pages/Search.js